import React from 'react'
import { observable, action, makeObservable } from 'mobx'
import i18n from 'i18next'
import { v4 as uuidv4 } from 'uuid'
import * as R from 'ramda'
import queryString from 'query-string'
import * as Widgets from './SalesIntelligenceWidgets'
import { getProductMap } from '../../utils/helpers'

class SalesIntelligenceStore {
    @observable product

    @observable surveyId

    @observable products

    @observable companyPageData

    @observable page = 'companyView' // exhibitorView, eventPicker

    @observable company

    @observable loading = false

    @observable error = ''

    productMap = {}

    constructor(store) {
        makeObservable(this)
        this.appStore = store
    }

    init = async () => {
        const { location } = window
        await this.getProducts()
        const params = queryString.parse(location.search)
        this.product = this.products.find((p) => p.productId === Number(params.productId))
        const productMap = await getProductMap(this.appStore.http, this.appStore.userData.clientId)
        this.productMap = productMap
        this.getCompany()
        if (this.company) {
            this.page = 'exhibitorView'
            this.changeExhibitor({ value: this.company })
        }
    }

    initCompanyPage = async () => {
        try {
            this.error = ''
            const { appStore } = this

            const companyPageData = await appStore.http.post(
                '/salesIntelligence/company',
                JSON.stringify({ productId: this.product.productId }),
            )

            this.surveyId = companyPageData.surveyId

            this.companyPageData = {
                salesIntelligenceMatrix: companyPageData.salesIntelligenceMatrix,
                exhibitorList: companyPageData.exhibitorList,
            }
        } catch (e) {
            console.log('error: ', e)
            this.error = 'noData'
            this.loading = false
        }
    }

    initExhibitorPage = async () => {
        try {
            this.error = ''
            this.loading = true
            const { appStore, company } = this
            const exhibitorPageData = await appStore.http.post(
                '/salesIntelligence/exhibitor',
                JSON.stringify({ productId: this.product.productId, companyName: company }),
            )

            this.surveyId = exhibitorPageData.surveyId

            this.exhibitorPageData = {
                EEI: exhibitorPageData.EEI,
                ECI: exhibitorPageData.ECI,
                NPS: exhibitorPageData.NPS,
                LoR: exhibitorPageData.LoR,
                objectives: exhibitorPageData.objectives,
                salesIntelligenceMatrix: exhibitorPageData.salesIntelligenceMatrix,
                allTextQuestions: exhibitorPageData.allTextQuestions,
            }
            this.loading = false
        } catch (e) {
            console.log('error: ', e)
            if (e?.message === 'Objectives Question not found') {
                this.error = 'noObjectivesQuestion'
            } else {
                this.error = 'noData'
            }
            this.loading = false
        }
    }

    changePage = (page) => { this.page = page }

    getCompany = () => {
        const url = new URL(window.location.href)

        const company = url.searchParams.get('companyName')

        if (company === null) {
            return false
        }

        this.company = company
        return true
    }

    getProducts = async () => {
        const { appStore } = this
        try {
            const products = await appStore.http.get('/product')
            this.products = products
        } catch (e) {
            return {}
        }
    }

    changeExhibitor = ({ value }) => {
        this.company = value
        const url = new URL(window.location.href)

        url.searchParams.set('companyName', value)

        window.history.replaceState({}, '', url)
        this.initExhibitorPage()
    }
}

export default SalesIntelligenceStore
